<div>
    <vl-radio-tile value="0" id="registration-orginanisation" name="registration-type"
                   key="orginanisation-key" v-model="registration"
                   title="Voor een organisatie"
                   info="De ingediende planaanvragen en hun bijhorende antwoorden zijn zichtbaar voor u en uw collega’s. De facturen en betalingsbewijzen staan op naam van uw organisatie. Beheert u leidingen? Registreer u dan ook als organisatie." />
    <vl-radio-tile value="1" id="registration-citizen" name="registration-type"
                   key="citizen-key" v-model="registration"
                   title="Als particulier"
                   info="U kan plannen aanvragen en bekijken. Enkel u kan uw ingediende planaanvragen en hun bijhorende antwoorden zie" />
</div>